
import { defineComponent } from 'vue'
import usePostsLoader from '@/composables/post/postLoader'
import PostFlatBranch from '@/components/Post/PostFlatBranch.vue'

export default defineComponent({
  name: 'PostBestList',
  components: { PostFlatBranch },
  async setup() {
    const { postList, clearListData, loadNext } = usePostsLoader()
    clearListData()
    loadNext()

    return {
      postList,
    }
  },
})
